import { useRef } from "react";
import { useOnClickOutside } from "usehooks-ts";
import useSearchDialogForm from "~/features/SearchV3/hooks/useSearchDialogForm";
import { useHelperStore } from "~/stores";

import SearchTopBar from "~/features/SearchV3/components/SearchDialog/SearchTopBar";
import ViewSelect from "~/features/SearchV3/components/SearchDialog/ViewSelect";
import ViewSearch from "./ViewSearch";
import KeywordInput from "./KeywordSearch/KeywordInput";
import { SEARCH_VIEW_MODE } from "~/types/search.types";
import TextSelectionInfo from "./Footer/TextSelectionInfo";
import BtnSearch from "./Footer/BtnSearch";
import BtnReset from "./Footer/BtnReset";
import { useLocation } from "react-router-dom";

const SearchDialogForm = () => {
    const { isFetching, totalSelectedItems, resetSelection, closeModal } = useSearchDialogForm();

    const viewMode = useHelperStore(state => state.viewMode);
    const clickRef = useRef(null);
    const location = useLocation();

    useOnClickOutside(clickRef, () => {
        if (location.pathname === "/search") {
            resetSelection(true);
        } else {
            closeModal(true);
        }
    });

    const viewElementContent =
        viewMode === SEARCH_VIEW_MODE.SELECTION ? <ViewSelect /> : <ViewSearch />;

    return (
        <div
            className="flex flex-col items-center w-full xl:w-[72rem] max-w-6xl h-[50.5rem] max-h-[95vh] rounded-2xl overflow-hidden"
            ref={clickRef}
        >
            {/** Disclosures dropdown menu */}
            <div className="flex items-center gap-1 py-3 px-4 w-full min-w-[47.5rem] h-16">
                <SearchTopBar />
            </div>

            {/** Search bar */}
            <div className="w-full pt-0 pb-4 px-4">
                <KeywordInput />
            </div>

            {/** Body */}
            <div
                className="w-full h-[38.25rem] border-y border-[rgba(166, 160, 155, 0.20)]"
                style={{ overflowY: "auto" }}
            >
                {viewElementContent}
            </div>

            {/** Footer Buttons */}
            <div className="w-full flex justify-between items-center gap-3 h-16 px-3 py-4">
                <div className="text-base text-stone-vibrant font-medium-light tracking-[-0.28px]">
                    <TextSelectionInfo />
                </div>

                <div className="flex gap-3">
                    {totalSelectedItems > 0 && (
                        <BtnReset isDisabled={isFetching} resetFn={() => resetSelection()} />
                    )}
                    <BtnSearch isLoading={isFetching} />
                </div>
            </div>
        </div>
    );
};

export default SearchDialogForm;
